module.exports = __webpack_public_path__ + "img/zm.1c375d50.svg";